import * as React from 'react';

import { Pill, PillProps } from '@components/common/Pill';
import { Tooltip } from '@components/Tooltip';

export type QualificationStatus = 'qualified' | 'partial' | 'disqualified' | 'no_data';

export const QUALIFICATION_COLORS: Record<QualificationStatus, PillProps['color']> = {
  qualified: 'green',
  partial: 'yellow',
  disqualified: 'red',
  no_data: 'gray'
};

export const QUALIFICATION_TEXTS: Record<QualificationStatus, string> = {
  qualified: 'Qualified',
  partial: 'Partial',
  disqualified: 'Disqualified',
  no_data: 'No Data'
};

export const QUALIFICATION_TOOLTIPS: Record<QualificationStatus, string> = {
  qualified: "Selected all of the screener's qualifying answers.",
  disqualified: "Selected at least one of the screener's disqualifying answers.",
  partial: "Selected at least one of the screener's qualifying, and no disqualifying, answers.",
  no_data: 'Screener may not have had qualifying criteria, or the candidate did not complete it.'
};

interface Props {
  screenerQualificationStatus?: QualificationStatus | null;
}

export const QualificationPill: React.FC<Props> = ({ screenerQualificationStatus }) => {
  const status: QualificationStatus =
    screenerQualificationStatus && screenerQualificationStatus in QUALIFICATION_TEXTS
      ? screenerQualificationStatus
      : 'no_data';

  return (
    <Tooltip content={QUALIFICATION_TOOLTIPS[status]}>
      <Pill color={QUALIFICATION_COLORS[status]} className='ml-2'>
        {QUALIFICATION_TEXTS[status]}
      </Pill>
    </Tooltip>
  );
};
